module.exports = __webpack_public_path__ + "media/images/bg/ribbon-118f974dccd58c641d0dd1c448139122.svg";